import "@/App.css";
import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { CookieConsent } from "@/components/CookieConsent";
import { AnnouncementBanner } from "@/components/AnnouncementBanner";

import Home from "@/pages/Home";
import Technology from "@/pages/Technology";
import QCore from "@/pages/QCore";
import HowItWorks from "@/pages/HowItWorks";
import Strategies from "@/pages/Strategies";
import Security from "@/pages/Security";
import Partners from "@/pages/Partners";
import Leadership from "@/pages/Leadership";
import Roadmap from "@/pages/Roadmap";
import About from "@/pages/About";
import Team from "@/pages/Team";
import Events from "@/pages/Events";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import Compliance from "@/pages/Compliance";
import Verify from "@/pages/Verify";
import SignalsProduct from "@/pages/SignalsProduct";
import VIPProduct from "@/pages/VIPProduct";
import Pricing from "@/pages/Pricing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Admin from "@/pages/Admin";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import DashboardLayout from "@/pages/dashboard/DashboardLayout";
import Overview from "@/pages/dashboard/Overview";
import QuantumVerse from "@/pages/dashboard/QuantumVerse";
import Activities from "@/pages/dashboard/Activities";
import {
  QCoreSection, MembershipSection, VirtualCardSection, WithdrawalsSection,
  ReferralsSection, QuantumFlexSection, ResourcesSection, SecuritySection, ProfileSection,
  SignalsSection, TrainingsSection, SupportSection,
} from "@/pages/dashboard/sections";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname]);
  return null;
}

function SiteLayout({ children }) {
  return (
    <div className="App min-h-screen bg-[#030305] text-[#F8FAFC]">
      <Navbar />
      <main>{children}</main>
      <Footer />
      <CookieConsent />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Toaster position="top-right" theme="dark" richColors offset={72} />
        <Routes>
          <Route path="/" element={<SiteLayout><Home /></SiteLayout>} />
          <Route path="/technology" element={<SiteLayout><Technology /></SiteLayout>} />
          <Route path="/q-core" element={<SiteLayout><QCore /></SiteLayout>} />
          <Route path="/how-it-works" element={<SiteLayout><HowItWorks /></SiteLayout>} />
          <Route path="/strategies" element={<SiteLayout><Strategies /></SiteLayout>} />
          <Route path="/security" element={<SiteLayout><Security /></SiteLayout>} />
          <Route path="/partners" element={<SiteLayout><Partners /></SiteLayout>} />
          <Route path="/leadership" element={<SiteLayout><Leadership /></SiteLayout>} />
          <Route path="/roadmap" element={<SiteLayout><Roadmap /></SiteLayout>} />
          <Route path="/about" element={<SiteLayout><About /></SiteLayout>} />
          <Route path="/team" element={<SiteLayout><Team /></SiteLayout>} />
          <Route path="/events" element={<SiteLayout><Events /></SiteLayout>} />
          <Route path="/faq" element={<SiteLayout><FAQ /></SiteLayout>} />
          <Route path="/contact" element={<SiteLayout><Contact /></SiteLayout>} />
          <Route path="/compliance" element={<SiteLayout><Compliance /></SiteLayout>} />
          <Route path="/verify" element={<SiteLayout><Verify /></SiteLayout>} />
          <Route path="/signals" element={<SiteLayout><SignalsProduct /></SiteLayout>} />
          <Route path="/vip" element={<SiteLayout><VIPProduct /></SiteLayout>} />
          <Route path="/pricing" element={<SiteLayout><Pricing /></SiteLayout>} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route
            path="/dashboard"
            element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}
          >
            <Route index element={<Overview />} />
            <Route path="quantum-verse" element={<QuantumVerse />} />
            <Route path="activities" element={<Activities />} />
            <Route path="q-core" element={<QCoreSection />} />
            <Route path="signals" element={<SignalsSection />} />
            <Route path="trainings" element={<TrainingsSection />} />
            <Route path="membership" element={<MembershipSection />} />
            <Route path="virtual-card" element={<VirtualCardSection />} />
            <Route path="withdrawals" element={<WithdrawalsSection />} />
            <Route path="referrals" element={<ReferralsSection />} />
            <Route path="quantum-flex" element={<QuantumFlexSection />} />
            <Route path="resources" element={<ResourcesSection />} />
            <Route path="support" element={<SupportSection />} />
            <Route path="security" element={<SecuritySection />} />
            <Route path="profile" element={<ProfileSection />} />
          </Route>
          <Route
            path="/admin"
            element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>}
          />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
